<script lang="ts">
  import { params } from "@roxi/routify";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import LogInOrSignUp from "@modern/components/retailer/SpecsOnboarding/LogInOrSignUp.svelte";
  import NoMatchFound from "@modern/components/retailer/SpecsOnboarding/NoMatchFound.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";

  const load = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/specs_onboarding_checks/matches_specs_retailer",
      data: {
        account_number: $params["account_number"],
        initialization_vector: $params["initialization_vector"],
      },
    });
  };

</script>

{#await load()}
  <Spinner />
{:then matchingRetailerDistributor}
  <FizzStyles>
    {#if matchingRetailerDistributor}
      <LogInOrSignUp
        accountNumber={$params["account_number"]}
        initializationVector={$params["initialization_vector"]}
      />
    {:else}
      <NoMatchFound />
    {/if}
  </FizzStyles>
{/await}
